import React from 'react';

interface ToggleButtonProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  icon?: React.ComponentType<{ size: number }>;
  variant?: 'primary' | 'success' | 'warning';
}

const ToggleButton: React.FC<ToggleButtonProps> = ({ 
  active, 
  onClick, 
  children, 
  icon: Icon, 
  variant = 'primary' 
}) => {
  const baseClasses = `
    flex items-center justify-center gap-2 px-4 py-3 rounded-lg font-medium transition-all duration-200
    border-2 cursor-pointer select-none
    hover:shadow-md active:scale-95
  `;
  
  const variantClasses: Record<string, string> = {
    primary: active 
      ? 'bg-blue-600 border-blue-600 text-white shadow-lg' 
      : 'bg-white border-blue-200 text-blue-700 hover:border-blue-300 hover:bg-blue-50',
    success: active 
      ? 'bg-green-600 border-green-600 text-white shadow-lg' 
      : 'bg-white border-green-200 text-green-700 hover:border-green-300 hover:bg-green-50',
    warning: active 
      ? 'bg-yellow-600 border-yellow-600 text-white shadow-lg' 
      : 'bg-white border-yellow-200 text-yellow-700 hover:border-yellow-300 hover:bg-yellow-50'
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]}`}
      onClick={onClick}
    >
      {Icon && <Icon size={16} />}
      {children}
    </button>
  );
};

export default ToggleButton;
